const translations = {
    errorNotesMax: 'Notes cannot exceed {{charMax}} characters',
    notes: 'Notes'
};

export default translations;
